import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface ChainLinkIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const ChainLinkIcon: React.FC<ChainLinkIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon chain-link')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512">
        <path d="M303.4 64C383.3 64 448 128.7 448 208.6C448 279.3 396.9 339.6 327.2 351.2L325.3 351.6C307.8 354.5 291.3 342.7 288.4 325.3C285.5 307.8 297.3 291.3 314.7 288.4L316.6 288.1C355.5 281.6 384 248 384 208.6C384 164.1 347.9 128 303.4 128H144.6C100.1 128 64 164.1 64 208.6C64 248 92.49 281.6 131.4 288.1L133.3 288.4C150.7 291.3 162.5 307.8 159.6 325.3C156.7 342.7 140.2 354.5 122.7 351.6L120.8 351.2C51.11 339.6 0 279.3 0 208.6C0 128.7 64.74 64 144.6 64H303.4zM336.6 448C256.7 448 192 383.3 192 303.4C192 232.7 243.1 172.4 312.8 160.8L314.7 160.4C332.2 157.5 348.7 169.3 351.6 186.7C354.5 204.2 342.7 220.7 325.3 223.6L323.4 223.9C284.5 230.4 256 263.1 256 303.4C256 347.9 292.1 384 336.6 384H495.4C539.9 384 576 347.9 576 303.4C576 263.1 547.5 230.4 508.6 223.9L506.7 223.6C489.3 220.7 477.5 204.2 480.4 186.7C483.3 169.3 499.8 157.5 517.3 160.4L519.2 160.8C588.9 172.4 640 232.7 640 303.4C640 383.3 575.3 448 495.4 448H336.6z" />
      </svg>
    </Tooltip>
  );
};
